import { apiClient } from "@/api/axios";
import type {
  CheckRecordRequest,
  CheckRecordResponse,
  RegistrationRequest,
  RegistrationResponse,
  GetCategoryResponse,
  GetCategoryRequest,
  ReferenceRquest,
  GetFormReferenceResponse,
  ReapplyRequest,
  ReapplyResponse,
} from "@/features/public/types/public";
import type { ApiResponse } from "@/types/api";

{
  /* Check Record */
}
export const checkRecord = async (
  request: CheckRecordRequest,
): Promise<ApiResponse<CheckRecordResponse>> => {
  const response = await apiClient.post<ApiResponse<CheckRecordResponse>>(
    "/api/v1/registration/check_record",
    request,
  );

  return response.data;
};

{
  /* Get Category */
}
export const getCategories = async (
  request: GetCategoryRequest,
): Promise<ApiResponse<GetCategoryResponse>> => {
  const response = await apiClient.post<ApiResponse<GetCategoryResponse>>(
    "/api/v1/registration/get_category_list",
    request,
  );

  return response.data;
};

{
  /* Get References */
}
export const getReferences = async (
  request: ReferenceRquest,
): Promise<ApiResponse<GetFormReferenceResponse>> => {
  const response = await apiClient.post<ApiResponse<GetFormReferenceResponse>>(
    "/api/v1/registration/get_form_reference",
    request,
  );

  return response.data;
};

{
  /* Registration */
}
export const registration = async (
  request: RegistrationRequest,
): Promise<ApiResponse<RegistrationResponse>> => {
  const response = await apiClient.post<ApiResponse<RegistrationResponse>>(
    "/api/v1/registration/submit",
    request,
  );

  return response.data;
};

{
  /* Reapply */
}
export const reapply = async (
  request: ReapplyRequest,
): Promise<ApiResponse<ReapplyResponse>> => {
  const response = await apiClient.post<ApiResponse<ReapplyResponse>>(
    "/api/v1/registration/reapply",
    request,
  );

  return response.data;
};
